import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { HttpResponse, HttpEventType, HttpHeaderResponse } from '@angular/common/http';
import { ProjectViewService } from './project.view.service';
import { AppService } from '../../app.service';
import { ActivatedRoute } from '@angular/router'; 
import { Location } from '@angular/common';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { PersonViewService } from '../../PersonComponent/PersonViewComponent/person.view.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { Globals } from '../../globals';

@Component({
    selector: 'project-comp',
    providers: [AppService, ProjectViewService, NgxSmartModalService, ConfirmService, PersonViewService], 
    templateUrl: './project.view.component.html',  
    styleUrls: ['../project.component.css']  
})

export class ProjectViewComponent {   

    selectedFiles: FileList;
    currentFileUpload: FileLikeObject;
    public uploader: FileUploader = new FileUploader({});
    private attachmentContent: any;
    private showContentForAttachment: Boolean = false;

    private newAttachment: Boolean = false;
    showAttBody: Boolean = false;
    private activeComponent: boolean;
    private project: any;
    showControlReasonVar: boolean = true;
    showProjectDetailsVar: boolean = true;
    showContactPersonDetails: boolean = true;
    id: String;
    ready: Boolean = false;
    showLoader: Boolean = false;

    constructor(
        private service: ProjectViewService,
        private activatedRoute: ActivatedRoute,
        private ngxSmartModalService: NgxSmartModalService,
        private personViewService: PersonViewService,
        private location: Location,
        private confirmService: ConfirmService,
        private sanitizer: DomSanitizer,
        private appService: AppService,
        private globals: Globals) { 
            this.activeComponent = appService.isComponentActive('project');
            this.id = this.activatedRoute.snapshot.paramMap.get('id');
            this.setDefault();
        }

    /**
     * Initiate all fields
     */
    setDefault() {
        this.getProjectById(this.id);
    }

    /**
     * Fetch a project from the database based on ID
     * @param id identifier for project to be retrieved
     */
    getProjectById(id) {
        this.service.getProjectById(id)      
        .subscribe(
          data => this.displayProject(data),
          error =>  this.showError(error.error),  
          () => this.showLoader = false      
        );  
    }

    /**
     * Show/Hide project details
     */
    showProjectDetails() {
        this.showProjectDetailsVar = !this.showProjectDetailsVar;
    }

    /**
     * Soft deletes a project
     * @param projectId unique identifier for the project to be deleted
     */
    softDeleteProject(projectId) {
        this.confirmService.confirm('Vill du verkligen ta bort projektet ' + this.project.suaName + '?')
            .then(result => {
                if (result) {
                    this.service.softDeleteProject(projectId)
                    .subscribe(
                        data => this.displayProject(data),
                        error => this.showError(error.error)
                    )
                }
            });
    }

    /**
     * Go back to the previous view from where we came
     */
    back() {
        this.appService.setRoute('/project');
    }

    /**
     * Shows or hides contact person details
     */
    toggleContactPersonDetails() {
        this.showContactPersonDetails = !this.showContactPersonDetails;
    }

    /**
     * Shows or hides the control reasons
     */
    toggleControlReason() {
        this.showControlReasonVar = !this.showControlReasonVar;
    }

    /**
     * Show error
     * @param error error text
     */
    showError(error) {   
        this.showLoader = false;
        this.confirmService.error(error.message);
    }

     /**
     * Display a selected project
     * @param data project returned from backend
     */
    displayProject(data) {
        this.project = data;
        this.ready = true;
    }

    /**
     * Sets route destination
     * @param destination destination path
     */
    setRoute(destination) {
        this.appService.setRoute(destination);
    }

    showAttachment() {
        this.ngxSmartModalService.getModal('attachmentModal').open();
    }

   /* ngAfterViewInit() {
        this.ngxSmartModalService.getModal('attachmentModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
            // modal is the dismissed modal, so do what you want with it
            this.resetModal();
        });
    }*/

    resetModal() {
        this.newAttachment = false;
        this.showAttBody = false;
        this.uploader.clearQueue();
    }

    showAttachmentBody() {
        this.showAttBody = true;
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    showUploader() {
        this.newAttachment = true;
    }

    getFiles(): FileLikeObject[] {
        return this.uploader.queue.map((fileItem) => {
            return fileItem.file;
        });
    }

    upload() {
        let files = this.getFiles();

        for(let i=0; i < files.length; i++) {
            let formData = new FormData();
            formData.append('file', files[i].rawFile, files[i].name);
            this.personViewService.upload(formData).subscribe(event => {
                if(event.status != 200) {
                    return;
                }
                if(event instanceof HttpResponse) {
                    let suaAttachment = {
                        readableName: files[i].name,
                      }
                      this.personViewService.saveAttachment(suaAttachment, "sua", this.project.id).subscribe(
                          data => this.uploadReady(),
                          error => console.log(error)
                      )
                }
            })
        }
    }

    renderAttachment(data) {
        var file = new Blob([(data)], {type: 'application/pdf'});
        var fileUrl = URL.createObjectURL(file);
        this.sanitizeUrl(fileUrl);
    }

    sanitizeUrl(url) {
        this.attachmentContent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.showContentForAttachment = true;
    }

    showAttachedFile(id) {
        this.personViewService.showAttachedFile(id).subscribe(
            data => this.renderAttachment(data),
            error => console.log(error)
        );
    }

    uploadReady() {
        this.getProjectById(this.id);
        this.uploader.clearQueue();
        this.newAttachment = false;
    }

    backToOverview() {
        this.newAttachment = false;
    }
}